// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link {\n  line-height: normal;\n}\n.link.active {\n  cursor: default;\n  text-decoration: underline;\n}\n.link.disabled {\n  color: #AEAEAE;\n  font-style: italic;\n  cursor: default;\n  text-decoration: none;\n}\n", ""]);
// Exports
module.exports = exports;
